import React from 'react';
import { ConfirmationBlock } from '../types';
import BEM from 'common/bem';

const classes = BEM.with('ConfirmationCard');

type ConfirmationCardProps = {
  data: ConfirmationBlock;
};

export default function ConfirmationCard({ data }: ConfirmationCardProps) {
  return (
    <div className={classes()}>
      <span className={classes('icon')}>&#10003;</span>
      <span className={classes('label')}>{data.field}:</span>
      <span className={classes('value')}>{data.value}</span>
    </div>
  );
}
